<script lang="ts">
  import clsx from 'clsx';

  const { sizeClass = 'w-full h-full' }: { sizeClass?: string } = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 -960 960 960"
  fill="currentcolor"
  class={clsx(sizeClass, 'overflow-hidden align-middle')}
  ><path
    d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"
  /></svg
>
